import React, { useState } from 'react';
import { Controller, Control, FieldErrors } from 'react-hook-form';
import { useTranslation } from "react-i18next";
import { InputLabel, Size } from "@laerdal/life-react-components";
import { InputCell, DropdownContainer, CaseDropdownFilter } from "../CaseFormPage.styles";

interface DropdownFieldProps {
    name: string;
    control: Control<any>;
    errors: FieldErrors<any>;
    label: string;
    required?: boolean;
    testId?: string;
    options: Array<{ displayLabel: string; value: string }>;
    disabled?: boolean;
}

export const FormDropdownField: React.FC<DropdownFieldProps> = ({
    name,
    control,
    errors,
    label,
    required = false,
    testId,
    options,
    disabled = false
}) => {
    const { t } = useTranslation("cases");

    if (disabled) {
        return (
            <Controller
                name={name}
                control={control}
                render={({ field }) => (
                    <input type="hidden" name={field.name} value={field.value ?? ''} />
                )}
            />
        );
    }

    return (
        <InputCell>
            <InputLabel inputId={name} text={label} size={Size.Small} required={required} />
            <DropdownContainer>
                <Controller
                    name={name}
                    control={control}
                    render={({ field }) => (
                        <CaseDropdownFilter
                            value={field.value}
                            activeValidationMessage={errors[name]?.message as string}
                            scrollable={true}
                            id={name}
                            dataTestId={testId || name}
                            list={options}
                            placeholder={t('-- Select an option --')}
                            onSelect={(value) => field.onChange(value)}
                            messageOnNoResults={t('No results found')}
                            size={Size.Medium}
                        />
                    )}
                />
            </DropdownContainer>
        </InputCell>
    );
};
